import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "node-infrastructure" }
const _hoisted_2 = {
  key: 0,
  class: "node-description"
}
const _hoisted_3 = ["onMouseenter", "onMouseleave"]
const _hoisted_4 = ["colspan"]
const _hoisted_5 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NodeInfrastructureOverview = _resolveComponent("NodeInfrastructureOverview")!
  const _component_Banner = _resolveComponent("Banner")!
  const _component_NodeMetadata = _resolveComponent("NodeMetadata")!
  const _component_PaginatedResourceTable = _resolveComponent("PaginatedResourceTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.listComponent)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "\n      Compute infrastructure for your Kubernetes cluster. Select nodes to manage scheduling or open a node for its configuration.\n    "))
      : _createCommentVNode("", true),
    _cache[6] || (_cache[6] = _createTextVNode()),
    (!_ctx.listComponent)
      ? (_openBlock(), _createBlock(_component_NodeInfrastructureOverview, {
          key: 1,
          nodes: _ctx.kubeNodes,
          "cluster-id": _ctx.$route.params.cluster,
          "cluster-name": _ctx.currentCluster?.nameDisplay || _ctx.currentCluster?.spec?.displayName || _ctx.$route.params.cluster,
          paginated: _ctx.canPaginate,
          "partial-scope": _ctx.canPaginate,
          "selected-role": _ctx.selectedRole,
          "selected-zone": _ctx.selectedZone,
          "role-choices": _ctx.roleChoices,
          "zone-choices": _ctx.zoneChoices,
          onToggleRole: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleInventoryFilter('role', $event))),
          onToggleZone: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleInventoryFilter('zone', $event))),
          onClearFilters: _ctx.clearInventoryFilters
        }, null, 8, ["nodes", "cluster-id", "cluster-name", "paginated", "partial-scope", "selected-role", "selected-zone", "role-choices", "zone-choices", "onClearFilters"]))
      : _createCommentVNode("", true),
    _cache[7] || (_cache[7] = _createTextVNode()),
    (_ctx.hasWindowsNodes)
      ? (_openBlock(), _createBlock(_component_Banner, {
          key: 2,
          color: "info",
          label: _ctx.t('cluster.custom.registrationCommand.windowsWarning')
        }, null, 8, ["label"]))
      : _createCommentVNode("", true),
    _cache[8] || (_cache[8] = _createTextVNode()),
    _createVNode(_component_PaginatedResourceTable, _mergeProps({
      ref: "inventory",
      "local-filter": _ctx.filterInventory,
      "api-filter": _ctx.filterInventoryApi
    }, _ctx.$attrs, {
      schema: _ctx.schema,
      headers: _ctx.headers,
      paginationHeaders: _ctx.paginationHeaders,
      "sub-rows": true,
      fetchSecondaryResources: _ctx.fetchSecondaryResources,
      fetchPageSecondaryResources: _ctx.fetchPageSecondaryResources,
      "use-query-params-for-simple-filtering": _ctx.useQueryParamsForSimpleFiltering,
      "data-testid": "cluster-node-list"
    }), {
      "sub-row": _withCtx(({fullColspan, row, onRowMouseEnter, onRowMouseLeave}) => [
        _createElementVNode("tr", {
          class: _normalizeClass(["taints sub-row", {'empty-taints': ! row.displayTaintsAndLabels}]),
          onMouseenter: onRowMouseEnter,
          onMouseleave: onRowMouseLeave
        }, [
          (row.displayTaintsAndLabels)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[2] || (_cache[2] = _createElementVNode("td", { "aria-hidden": "true" }, null, -1)),
                _cache[3] || (_cache[3] = _createTextVNode()),
                _cache[4] || (_cache[4] = _createElementVNode("td", { "aria-hidden": "true" }, null, -1)),
                _cache[5] || (_cache[5] = _createTextVNode()),
                _createElementVNode("td", {
                  colspan: fullColspan-2
                }, [
                  _createVNode(_component_NodeMetadata, {
                    node: row,
                    "taints-label": _ctx.t('node.list.nodeTaint'),
                    "labels-label": _ctx.t('node.list.nodeLabels')
                  }, null, 8, ["node", "taints-label", "labels-label"])
                ], 8, _hoisted_4)
              ], 64))
            : (_openBlock(), _createElementBlock("td", {
                key: 1,
                colspan: fullColspan
              }, null, 8, _hoisted_5))
        ], 42, _hoisted_3)
      ]),
      _: 1
    }, 16, ["local-filter", "api-filter", "schema", "headers", "paginationHeaders", "fetchSecondaryResources", "fetchPageSecondaryResources", "use-query-params-for-simple-filtering"])
  ]))
}